class Toolbarmobile extends HTMLElement {
  constructor() {
    super();

    if (theme.config.mqlSmall || theme.config.isTouch) {
      if (typeof requestAnimationFrame === 'function') {
        requestAnimationFrame(() => this.init());
      } else {
        this.init();
      }
    }
  }

  init() {
    this.activate();
    this.setHeight();
    window.addEventListener('resize', theme.utils.rafThrottle(this.setHeight.bind(this)), { passive: true });
  }

  activate() {
    const header = document.querySelector(".header[data-sticky-state='inactive']");
    header === null
      ? this.classList.add("active")
      : this.classList.remove("active");
  }

  setHeight() {
    if (!this.clientHeight) return;
    document.body.style.setProperty('--toolbar-mobile-height', `${this.clientHeight}px`);
  }
}
customElements.define("toolbar-mobile", Toolbarmobile);
